module.exports = __webpack_public_path__ + "static/media/mb-banner-home-6.bcd5b039.jpg";